import { TextLink } from 'copilot-design-system';
import { Trans, useTranslation } from 'react-i18next';

import { Callout } from 'src/components/Callout';
import { assemblyDashboardHostnameProd } from 'src/constants/middlewareConsts';
import { ArrowNEIcon } from 'src/legacy/components/Icons';

interface BrandRedirectCalloutProps {
  footerLinkHref?: string;
  footerLinkLabel?: string;
  hideFooterLinkArrow?: true;
}

export const BrandRedirectCallout: React.FC<BrandRedirectCalloutProps> = (
  props,
) => {
  const { t } = useTranslation();

  return (
    <aside className="flex justify-center">
      <Callout
        className="max-w-lg"
        status="neutral"
        label={
          <>
            <span className="block font-medium">
              {t(($) => $.page_onboarding.brand_redirect_callout.title)}
            </span>

            <span className="block mt-1.5 font-light">
              <Trans
                i18nKey="page_onboarding.brand_redirect_callout.description"
                components={{
                  Link: (
                    <TextLink
                      variant="secondary"
                      className="inline"
                      href={`https://${assemblyDashboardHostnameProd}`}
                    />
                  ),
                }}
              />
            </span>

            {props.footerLinkHref ? (
              <TextLink
                className="mt-1.5 font-normal"
                href={props.footerLinkHref}
                target="_blank"
              >
                {props.footerLinkLabel ??
                  t(($) => $.page_onboarding.brand_redirect_callout.btn_label)}

                {props.hideFooterLinkArrow ? null : (
                  <ArrowNEIcon className="size-5 ml-[-4px]" />
                )}
              </TextLink>
            ) : null}
          </>
        }
      />
    </aside>
  );
};
